<script>
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import { debounce } from "@/helpers/debounce";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "detail-rekap-peserta",
  props: ["userId"],
  components: { Datatable, Pagination },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      { width: "50px", label: "No", name: "pbl_id" },
      { width: "auto", label: "Kode", name: "pbl_kode" },
      { width: "auto", label: "Judul", name: "pbl_judul" },
      { width: "auto", label: "Durasi HE", name: "pbl_durasi_he" },
      { width: "auto", label: "Durasi JP", name: "pbl_durasi_jp" },
      { width: "auto", label: "Tipe", name: "pbl_lt_name" },
      { width: "auto", label: "Tanggal Mulai", name: "pbl_tgl_mulai" }, // jika tidak ada sorting kasih name dengan karakter -
      { width: "auto", label: "Tanggal Selesai", name: "pbl_tgl_selesai" },
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      user_id: this.userId,

      // variable Page Table
      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "pbl_id", // sort key awal
      sortOrders: sortOrders,
      currentTablePage: "",

      // parsing data ke table data
      tableData: {
        draw: 0,
        length: 10,
        search: "",
        column: 0,
        dir: "asc",
        userId: this.userId,
      },

      // config untuk paginasi
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
    };
  },
  created() {
    this.searchDatatable = debounce(() => {
      this.getDataTable();
      // call fetch API to get results
    }, 500);
  },
  mounted() {
    let self = this;
    self.getDataTable();
  },
  methods: {
    getDataTable(
      url = process.env.VUE_APP_BACKEND_URL_VERSION +
        "transactions/rekap/peserta/detail"
    ) {
      let self = this;
      self.loadingTable = true;
      self.tableData.draw++;

      var config = {
        method: "get",
        url: url,
        params: self.tableData,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data[0];
          if (response_data.meta.code == 200) {
            if (self.tableData.draw == response_data_fix.draw) {
              self.table_data = response_data_fix.list_data.data;
              self.configPagination(response_data_fix.list_data);
              self.currentTablePage = response_data_fix.list_data.current_page;
            }
            self.loadingTable = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    configPagination(data) {
      let self = this;
      self.pagination.lastPage = data.last_page;
      self.pagination.currentPage = data.current_page;
      self.pagination.total = data.total;
      self.pagination.lastPageUrl = data.last_page_url;
      self.pagination.nextPageUrl = data.next_page_url;
      self.pagination.prevPageUrl = data.prev_page_url;
      self.pagination.from = data.from;
      self.pagination.to = data.to;
      self.pagination.links = data.links;
    },
    sortBy(key) {
      let self = this;
      self.sortKey = key;
      self.sortOrders[key] = self.sortOrders[key] * -1;
      self.tableData.column = self.getIndex(self.columns, "name", key);
      self.tableData.dir = self.sortOrders[key] === 1 ? "asc" : "desc";
      self.getDataTable();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },
    toPage: function (str) {
      let self = this;
      self.getDataTable(str);
    },
  },
};
</script>
<style>
th {
  border-color: grey !important;
}

td {
  border-color: grey !important;
}
</style>
<template>
  <div class="row">
    <div class="col-12">
      <hr />
    </div>
    <div class="col-12 mb-2">
      <div class="row">
        <div class="col-md-4">
          <table>
            <tr>
              <td>Show</td>
              <td>
                <select
                  class="form-control form-control-sm"
                  id="showpaginatetable"
                  style="width: 100%"
                  v-model="tableData.length"
                  @change="getDataTable()"
                >
                  <option value="10" selected>10</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                </select>
              </td>
              <td>Entries</td>
            </tr>
          </table>
        </div>
        <div class="col-md-5">&nbsp;</div>
        <div class="col-md-3">
          <input
            type="text"
            class="form-control form-control-sm"
            id="searchTable"
            placeholder="Cari Data ..."
            v-model="tableData.search"
            @input="searchDatatable"
          />
        </div>
      </div>
    </div>
    <datatable
      :columns="columns"
      :sortKey="sortKey"
      :sortOrders="sortOrders"
      @sort="sortBy"
    >
      <tbody>
        <tr v-if="loadingTable">
          <td colspan="8"><i class="fas fa-spinner fa-spin"></i> Loading...</td>
        </tr>
        <tr v-else-if="table_data == ''">
          <td class="text-center" colspan="8">Data Tidak Tersedia</td>
        </tr>
        <tr v-else v-for="(row_data, key_data) in table_data" :key="key_data">
          <td class="text-center">
            <div v-if="key_data + 1 == 10">{{ currentTablePage }}0.</div>
            <div v-else>
              {{ currentTablePage - 1 != 0 ? currentTablePage - 1 : ""
              }}{{ key_data + 1 }}.
            </div>
          </td>
          <td class="text-center">
            {{ row_data.pbl_kode }}
          </td>
          <td>
            {{ row_data.pbl_judul }}
          </td>
          <td class="text-center">
            {{ row_data.pbl_durasi_he }}
          </td>
          <td class="text-center">
            {{ row_data.pbl_durasi_jp }}
          </td>
          <td class="text-center">
            {{ row_data.pbl_lt_name }}
          </td>
          <td class="text-center">
            {{ row_data.pbl_tgl_mulai }}
          </td>
          <td class="text-center">
            {{ row_data.pbl_tgl_selesai }}
          </td>
        </tr>
      </tbody>
    </datatable>
    <pagination :pagination="pagination" @to-page="toPage"></pagination>
  </div>
</template>
